export { default as CONTENT_TYPES } from "./contentfulTypenames";
export * from "./cookie";
export * from "./investors";
export * from "./locales";
export * from "./markets";
export * from "./navigation";
export * from "./newsTypes";
export * from "./seo";
export { default as THEMES } from "./themes";
export * from "./validation";
export * from "./dynamics";

export const SEARCH_SLUG = "search-results";
export const DPAM_TAG_ID = "content-dpam";
